import React from "react"
import { Grid } from "@mui/material"

import { AppProvidersAutocomplete, AppTiersAutocomplete } from "@components"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { BACKEND_APIS } from "@constants"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"


export default function AlertsMainProviders() {
	const {
		dataInfo: mainProvider, setDataInfo: setMainProvider
	} = useAlertsDataInfo(alertsDrawerData.peek().mainProvider || [])
	const {
		dataInfo: mainTiers, setDataInfo: setMainTiers
	} = useAlertsDataInfo(alertsDrawerData.peek().mainTiers || [])
	const {
		dataInfo: providersByTiers, setDataInfo: setProvidersByTiers
	} = useAlertsDataInfo((alertsDrawerData.peek()?.tiers && alertsDrawerData.peek().providers) && alertsDrawerData.peek().providers || [])

	return <Grid container spacing={3}>
		<Grid item xs={6}>
			<AppTiersAutocomplete
				multiple
				onChange={e => {
					setMainProvider(e.target.value.reduce((acc, curr) => [...acc, ...providersByTiers.value.find(t => t.key === curr).providers], []), 'mainProvider')
					setMainTiers(e.target.value, 'mainTiers')
				}}
				value={mainTiers.value}
				onFinishAjax={options => {
					setProvidersByTiers(options.map(t => ({
						key: t.value, providers: t.providers
					})), 'providersByTiers')
				}}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
				label="Main tiers"
				placeholder="All tiers for main provider"
			/>
		</Grid>
		<Grid item xs={6}>
			<AppProvidersAutocomplete
				label="Main Providers"
				value={mainProvider.value}
				onChange={e => setMainProvider(e.target.value, 'mainProvider')}
				disabled={!!mainTiers.value.length}
			/>
		</Grid>
	</Grid>

}